import React, { useState, useRef, useEffect } from "react";
import { makeStyles } from '@material-ui/core'
import ReactJWPlayer from 'react-jw-player';

const useStyles = makeStyles(theme => ({
    root: {
        display:'flex',
        flexGrow:1,
        justifyContent:'center',
        '& .jwplayer':{
            [theme.breakpoints.down('md')]:{
                height:'320px',
            },
            width:'100%',
            height:'400px'
        },
        '& .jw-knob': {
            visibility: 'hidden'
        }
    }
}))

const VideoJWPlayer = ({ jwPlayersrc = 'https://ssl.p.jwpcdn.com/player/v/8.12.2/jwplayer.js', jwPlayerkey = 'TcXQp67WgPCr0i2cUnpaYOkL/18qE3Xpl2kQIpezwar80ApC', videoURL, handleComplete }) => {
    const playerRef = useRef(null);
    const classes = useStyles()
    const [videoWatchComplete, setVideoWatchComplete]=useState(false)
    const [position, setPosition] = useState(0);
    useEffect(()=>{
        setVideoWatchComplete(false)
    },[videoURL])

    const handleOnTime = (e) => {
        console.log(e);
        const player = window.jwplayer('jwPlayerReferee');
        var positionDiff = e.position - position;
        if (positionDiff > 1) {
            player.seek(position);
        } else {
            setPosition(e.position);
        }
    }

    useEffect(()=>{
        if(videoWatchComplete){
            handleComplete(true)
        }
    },[videoWatchComplete])

    return (
        <div className={classes.root}  data-mediaid="jwPlayerReferee" style={{ height: "100%", width: "100%" }}>
            <ReactJWPlayer
               
                aspectratio='12:5'
                onContextMenu={(e) => e.preventDefault()}
                ref={playerRef}
                playerId='jwPlayerReferee'
                playerScript={jwPlayersrc}
                licenseKey={jwPlayerkey}
                file={videoURL}

                onTime={handleOnTime}
                onOneHundredPercent={() => {
                   setVideoWatchComplete(true)
                }}
            />
        </div>
    )
}

export default VideoJWPlayer;